const getPublishCount = (rootState) => rootState.site.publishCount;

export default getPublishCount;
